"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockTournamentUsers = {
    success: true,
    users: [
        {
            uuid: '1',
            email: 'email1',
            nickname: 'nickname1',
            avatar: 'avatar1',
            score: 1,
            status: 'invited',
        },
        {
            uuid: '2',
            email: 'email2',
            nickname: 'nickname2',
            avatar: 'avatar2',
            score: 2,
            status: 'joined',
        },
        {
            uuid: '3',
            email: 'email3',
            nickname: 'nickname3',
            avatar: 'avatar3',
            score: 3,
            status: 'participated',
        },
    ],
    statusUsers: {
        all: 3,
        invited: 1,
        joined: 1,
        participated: 1,
    },
};
exports.default = mockTournamentUsers;
